function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15 4.25a3 3 0 10-6 0 3 3 0 006 0zm-3 1.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm9.703 2.973a1.84 1.84 0 00-1.828-1.473H4.125a1.875 1.875 0 00-.786 3.578h.013l4.757 2.095-1.968 7.474a1.879 1.879 0 103.422 1.553L12 17.743l2.438 4.207a1.875 1.875 0 003.412-1.549l-1.969-7.473 4.758-2.096h.012a1.841 1.841 0 001.052-2.11zm-1.669.74l-5.337 2.35a.75.75 0 00-.423.877l2.145 8.154c.01.043.026.086.045.126a.375.375 0 11-.68.317.6.6 0 00-.031-.059l-3.104-5.353a.75.75 0 00-1.298 0l-3.1 5.348a.592.592 0 00-.033.06.375.375 0 11-.68-.317.657.657 0 00.046-.127l2.142-8.151a.75.75 0 00-.423-.878L3.966 9.463a.375.375 0 01.16-.713h15.75a.375.375 0 01.161.713h-.003z",
  fill: "#3A3544"
});

function SvgPersonArmsSpread(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgPersonArmsSpread;